import { Box, Stack, StatusChip } from '@presov.sk/presov-ui-react';
import type { StatusChipTone } from '@presov.sk/presov-ui-react';
import React from 'react';

type Props = {
  tone?: StatusChipTone;
  /** Farebná bodka pred textom - nesie ju len stav, nie údaj. */
  dot?: boolean;
  children: React.ReactNode;
};

/**
 * Pilulka s údajom o hlasovaní - stav, dokedy je otvorené, koľko má hlasov,
 * koľko otázok.
 *
 * Je to **`StatusChip` z knižnice**, nie vlastná plocha. Predtým to bola
 * kópia jeho tvaru s vlastnou tabuľkou farieb (`palette.blue.surface`,
 * `green.surface`, …) a rozišla sa s ním v dvoch veciach naraz: výška
 * neposlúchala `theme.controlHeight.tag` a tón `success` nemal to zosvetlenie
 * textu, ktoré `StatusChip` robí kvôli AA kontrastu. Zostáva tu len to, čo
 * knižnica nemá: bodka pred textom a spoločný riadok (`VotingBadges`).
 *
 * `tone` je preto priamo `StatusChipTone` - k štyrom pôvodným hodnotám
 * pribudol `error`.
 */
export const VotingBadge: React.FC<Props> = ({
  tone = 'neutral',
  dot,
  children,
}) => (
  <StatusChip tone={tone}>
    {/* `StatusChip` je inline-flex bez `gap`, takže riadok s bodkou a ikonou
        si nesie obsah sám. */}
    <Box
      component='span'
      sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.875 }}
    >
      {dot && (
        <Box
          component='span'
          sx={({ shape }) => ({
            width: 7,
            height: 7,
            flex: 'none',
            borderRadius: `${shape.borderRadiusFull}px`,
            backgroundColor: 'currentColor',
          })}
        />
      )}
      {children}
    </Box>
  </StatusChip>
);

export const VotingBadges: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <Stack direction='row' gap={1} flexWrap='wrap'>
    {children}
  </Stack>
);
